import { BoxProps, Checkbox, Flex, Grid, GridItem, Link, Text } from "@chakra-ui/react";

import { AuthMode, Scenario } from "@nens/ldo/api-v1";

import { ScenarioStatus } from "../scenario-status/scenario-status";

interface ScenarioListItemProps extends BoxProps {
  authMode: AuthMode;
  scenario: Scenario;
  checkbox?: boolean;
  checked?: boolean;
  setChecked?: (checked: boolean) => void;
}

export function ScenarioListItem({
  authMode,
  scenario,
  checkbox = true,
  checked,
  setChecked,
}: ScenarioListItemProps) {
  const templateColumns = "20px 0.8fr 100px 200px";

  return (
    <Grid
      gridTemplateColumns={templateColumns}
      gap={4}
      mr={4}
      py={2}
      px={4}
      h="60px"
      w="100%"
      cursor="pointer"
      _hover={{
        bgColor: "#FCF5F450",
      }}
      borderBottom="1px solid #cccccc40"
      title={scenario.name}
    >
      <GridItem>
        <Flex alignItems="center" mt="12px">
          {checkbox ? (
            <Checkbox
              isChecked={checked}
              onChange={(e) => setChecked && setChecked(e.target.checked)}
            />
          ) : null}
        </Flex>
      </GridItem>
      <GridItem w="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
        <Flex alignItems="center" mt="6px">
          <Link href={`/scenarios/${scenario.id}`} fontWeight="semibold" title={scenario.name}>
            {scenario.name}
          </Link>
        </Flex>
      </GridItem>
      <GridItem w="100%" h="10">
        <Flex alignItems="center" mt="6px">
          <Text fontWeight="normal">{scenario.id}</Text>
        </Flex>
      </GridItem>
      <GridItem w="100%" h="10" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
        {authMode === "private" ? (
          <ScenarioStatus status={scenario.status ?? undefined} />
        ) : (
          scenario.owner
        )}
      </GridItem>
    </Grid>
  );
}
